import { setContext } from '@apollo/client/link/context';
import { getSession } from '@side/next-auth/react';

interface OriginalContext {
  [k: string]: unknown;
  headers?: Record<string, unknown>;
}

// This auth link will add the authorization header
// with the Okta token.
export const authLink = setContext(
  async (_request, prevContext: OriginalContext) => {
    const session = await getSession();

    if (!session?.accessToken) {
      throw new Error('User is not authenticated.');
    }

    return {
      ...prevContext,
      headers: {
        ...prevContext.headers,
        authorization: `Bearer ${session.accessToken}`,
      },
    };
  },
);
